import { create } from 'zustand'
import { billingApi } from '@/api/billingApi'

const PAGE = 50

export const useBillingStore = create((set, get) => ({
  list: [],
  loading: false,
  loadingMore: false,
  hasMore: false,
  query: { patient_id: '', status: '', date_from: '', date_to: '' },

  fetchList: async (queryPatch = {}) => {
    const query = { ...get().query, ...queryPatch }
    set({ loading: true, query })
    try {
      const params = { limit: PAGE, offset: 0 }
      if (query.patient_id) params.patient_id = query.patient_id
      if (query.status) params.status = query.status
      if (query.date_from) params.date_from = query.date_from
      if (query.date_to) params.date_to = query.date_to
      const rows = await billingApi.list(params)
      set({
        list: rows,
        hasMore: rows.length === PAGE,
        loading: false,
      })
    } catch (e) {
      set({ loading: false })
      throw e
    }
  },

  nextPage: async () => {
    const { list, query, hasMore, loadingMore } = get()
    if (!hasMore || loadingMore) return
    set({ loadingMore: true })
    try {
      const params = { limit: PAGE, offset: list.length }
      if (query.patient_id) params.patient_id = query.patient_id
      if (query.status) params.status = query.status
      if (query.date_from) params.date_from = query.date_from
      if (query.date_to) params.date_to = query.date_to
      const rows = await billingApi.list(params)
      set({
        list: [...list, ...rows],
        hasMore: rows.length === PAGE,
        loadingMore: false,
      })
    } catch (e) {
      set({ loadingMore: false })
      throw e
    }
  },

  prepend: (bill) => {
    if (!bill?.bill_id) return
    set((state) => ({ list: [bill, ...state.list.filter((b) => b.bill_id !== bill.bill_id)] }))
  },

  upsert: (bill) => {
    if (!bill?.bill_id) return
    const list = get().list
    const idx = list.findIndex((b) => b.bill_id === bill.bill_id)
    if (idx >= 0) {
      const next = [...list]
      next[idx] = bill
      set({ list: next })
    }
  },
}))
